import ClickSpark from "utils/ClickSpark";
import LineBackground from "components/common/LineBackground"

import config from "config/config.dev"

const ProjectDetailLayout = ({ children }) => {
    const featureLineBackground = config.features.lineBackground || false;  // Splash Cursor Enable/Disable Switch
    return (
        <div>
            <ClickSpark
                sparkColor="#E91E63"
                sparkSize={13}
                sparkRadius={25}
                sparkCount={8}
                duration={500}
            >
                <div>
                    {/* Remove the following line to disable LineBackground permanently */}
                    {featureLineBackground ? <LineBackground /> : null}

                    {/* This is importing the children in the main Landing file. */}
                    {children}

                </div>
            </ClickSpark >
        </div>
    );
};

export default ProjectDetailLayout;